import { createModuleBuilder } from '@evidentid/dashboard-commons/app';
import { GatewayApiClient } from '@evidentid/gateway-api-client';
import Logger from '@evidentid/logger';
import Severity from '@evidentid/logger/Severity';
import Tracker from '@evidentid/tracker';

import ActionsReview from '@/modules/entity-actions-review/views/ActionReview/ActionsReview.vue';

const legacyRoutesRedirect = [
    {
        path: '/:rpId?/actions-review',
        redirect: '/:rpId?/actions',
    },
];

export const entityActionsReviewModule = createModuleBuilder()
    .registerRoutes(() => [
        {
            path: '/:rpId?/actions',
            name: 'entityActionsReview',
            component: ActionsReview as any,
            meta: { title: 'Actions Review', pageClass: 'ActionsReview' },
        },
        ...legacyRoutesRedirect,
    ])
    .demandContext<{
    gatewayClient: GatewayApiClient;
    tracker?: Tracker<any>;
    logger?: Logger<any>;
}>()
    .injectVue((app) => ({
        $gatewayClient: app.gatewayClient,
    }))
    .end();
